export default __webpack_public_path__ + "static/media/circleLogo.b5cae789.png";